import PropTypes from "prop-types"
import React, { useState } from "react"
import ContactSalesModal from "components/ContactSalesModal"
import { openModal } from "utils/openModal"
import { trackEvent } from "lib/googleTagManager"
import Button from "components/ui/Button"
import Container from "components/ui/Container"

function triggerDownload(url) {
  const link = document.createElement("a")
  link.href = url
  link.download = ""
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

function GatedWhitepaperCTA({
  label = "Free Whitepaper",
  heading,
  description,
  buttonText = "Download Whitepaper",
  pdfUrl,
  sourcePage,
  trackingName,
  coverImage = "/images/whitepapers/pcs-whitepaper-cover.png",
  coverImageAlt = "Preset-Certified Superset — Enterprise Analytics On Your Terms whitepaper cover",
}) {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [unlocked, setUnlocked] = useState(false)

  const handleSuccess = () => {
    setUnlocked(true)
    triggerDownload(pdfUrl)
    trackEvent("whitepaperDownloaded", {
      whitepaperUrl: pdfUrl,
      sourcePage,
    })
  }

  return (
    <section className="bg-white py-20">
      <Container>
        <div className="mx-auto grid max-w-5xl items-center gap-10 lg:grid-cols-2">
          <div>
            {label && (
              <p className="text-sm font-bold uppercase tracking-widest text-cove/60">
                {label}
              </p>
            )}
            <h2 className="mt-4 text-4xl font-bold leading-tighter text-cove md:text-5xl">
              {heading}
            </h2>
            {description && (
              <p className="mt-5 text-lg text-gray-600">{description}</p>
            )}
          </div>
          <div className="flex flex-col items-center text-center">
            <div className="overflow-hidden rounded-lg shadow-lg">
              <img src={coverImage} alt={coverImageAlt} className="w-64" />
            </div>
            <div className="mt-6">
              {unlocked ? (
                <Button
                  color="green"
                  size="medium"
                  trackClick={`${trackingName} (direct)`}
                  shadow
                  onClick={() =>
                    window.open(pdfUrl, "_blank", "noopener,noreferrer")
                  }
                >
                  Download PDF
                </Button>
              ) : (
                <Button
                  color="green"
                  size="medium"
                  href="/contact-sales/"
                  onClick={openModal(setIsModalOpen)}
                  trackClick={trackingName}
                  shadow
                >
                  {buttonText}
                </Button>
              )}
            </div>
          </div>
        </div>
      </Container>
      <ContactSalesModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        sourcePage={sourcePage}
        onSuccess={handleSuccess}
      />
    </section>
  )
}

GatedWhitepaperCTA.propTypes = {
  label: PropTypes.string,
  heading: PropTypes.string.isRequired,
  description: PropTypes.string,
  buttonText: PropTypes.string,
  pdfUrl: PropTypes.string.isRequired,
  sourcePage: PropTypes.string.isRequired,
  trackingName: PropTypes.string.isRequired,
  coverImage: PropTypes.string,
  coverImageAlt: PropTypes.string,
}

export default GatedWhitepaperCTA
